module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-8f731fe5656b49d0ff864e00c7bd016b.png";